'use client';

import { type HamburgerMenuItemProps, HamburgerMenuItem } from '..';

type HamburgerMenuItemsProps = {
  items?: Omit<HamburgerMenuItemProps, 'onMenuItemClick'>[];
  divider?: boolean;
  onMenuItemClick: () => void;
  firstItemRef?: React.RefObject<HTMLAnchorElement | null>;
};

function Divider() {
  return <hr className="h-px border-border" />;
}

function HamburgerMenuItems({ items, divider = false, firstItemRef, onMenuItemClick }: HamburgerMenuItemsProps) {
  if (!items?.length) return null;

  return (
    <>
      {divider && <Divider />}
      {items?.map((item, index) => (
        <HamburgerMenuItem
          key={item.label}
          variant={item.variant}
          icon={item.icon}
          label={item.label}
          link={item.link}
          onMenuItemClick={onMenuItemClick}
          dataTrackName={item.dataTrackName}
          showNotification={item.showNotification}
          focusRef={index === 0 ? firstItemRef : undefined}
        />
      ))}
    </>
  );
}

export { HamburgerMenuItems };
